angular.module('Itao.IndicatorMap').directive('indicatorDataLayers', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayers.html',
    restrict: 'E',
    scope: {
      selectedDataLayer: '=',
      selectedDataLayerType: '=',
      layers: '=',
      onDataLayerSelect: '&'
    },
    link: function (scope, element) {
      var years = [];
      var layerInterval = null;

      scope.intervalIsRunning = false;
      scope.playLayers = function() {
        if(!years.length) {
          saveYearsInsideArray();
        }
        layerInterval = $interval(showNextYear, 5000);

        jQuery(element).find('.progress').addClass('running');
        scope.intervalIsRunning = true;
      };

      function showNextYear() {
        var currentYearIndex = years.indexOf(scope.selectedDataLayer.year),
          nextIndex = currentYearIndex+1;

        if(currentYearIndex === years.length-1) {
          nextIndex = 0
        }

        var nextLayer = scope.layers[years[nextIndex]];
        scope.onDataLayerSelect({dataLayer: nextLayer});
      }

      scope.stopLayers = function() {
        jQuery(element).find('.progress').removeClass('running');
        $interval.cancel(layerInterval);
        scope.intervalIsRunning = false;
      };

      function saveYearsInsideArray() {
        angular.forEach(scope.layers, function(layer) {
          years.push(layer.year);
        });
      }
    }
  };
});
